







import { defineComponent } from '@vue/composition-api';
import Navbar from './Navbar.vue';
import MainArea from './MainArea.vue';

const Component = defineComponent({
  name: 'AppMain',

  components: {
    Navbar,
    MainArea,
  },
});

export default Component;
